import {createContext, Dispatch, ReactNode, SetStateAction, useContext, useMemo,} from 'react';
import {SxProps} from "@mui/material";

export interface ConfirmDialog {
  icon?: ReactNode;
  message?: string;
  children?: ReactNode;
  onClose?: () => void;
  onConfirm?: () => void;
  fullWidth?: boolean;
  fullScreen?: boolean;
  title?: ReactNode;
  titleSx?: SxProps;
  confirmText?: string;
  cancelText?: string;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
}

export const ConfirmDialogContext = createContext<ConfirmDialog | undefined>(
  undefined,
);
export const SetConfirmDialogContext = createContext<
  Dispatch<SetStateAction<ConfirmDialog | undefined>>
>(() => undefined);

export const useSetConfirmDialogContext = () =>
  useContext(SetConfirmDialogContext);

export function useConfirmDialog() {
  const setDialog = useSetConfirmDialogContext();
  
  return useMemo(
    () => ({
      close: () => setDialog(undefined),
      open: (dialog: ConfirmDialog): Promise<boolean> => {
        return new Promise((resolve) => {
          setDialog({
            ...dialog,
            onClose: () => {
              setDialog(undefined);
              resolve(false);
            },
            onConfirm: () => {
              setDialog(undefined);
              resolve(true);
            },
          });
        });
      },
    }),
    [setDialog],
  );
}
